import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICountry } from 'models/country';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  country: ICountry;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditCountry: React.FC<Props> = ({ open, loading, country, onClose, onSubmit, onChanges }) => {
const {t}=useTranslation()
  let basicFields: IFormField[] = [
    {
      name: 'Code',
      label: t('T_country_code'),
      type: InputTypes.TEXT,
      defaultValue: country.code,
      disabled: true,
      internalLabel: true,
      required: true
    },
    {
      name: 'name',
      label: t('T_enter_name'),
      type: InputTypes.TEXT,
      defaultValue: country.name,
      internalLabel: true,
      required: true
    },
    {
      name: 'nameAr',
      label:  `${t('T_enter_name')} ${t('T_in_arabic')}`,  
      type: InputTypes.TEXT,
      defaultValue: country.nameAr,
      internalLabel: true,
      required: true
    },

  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_country')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_edit')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditCountry;
